module.exports = __webpack_public_path__ + "static/media/locate-charging-stations.1f90c2c3.svg";